/**
 * 表格和外部下拉框联动
 */
import { getDocumentCookie, getQueryParam } from "@/utils"
export default {
  destroyed() {
    this.removeChartEvent()
  },
  methods: {
    addChartEvent() {
      this.handleChartEvent({ callback: this.chartEventFilterValue.bind(this) })
    },
    removeChartEvent() {
      this.handleChartEvent()
    },
    handleChartEvent(obj) {
      if (window.chartEventBus) {
        const eventMap = window.chartEventBus.eventMap
        const id = `container_id_${this.myid.container_id}-rect_id_${this.myid.rect_id}`
        for (let i in eventMap) {
          if (eventMap[i].includes(id)) {
            obj ? window.chartEventBus.on(i, { ...obj, id }) : window.chartEventBus.off(i, id)
          }
        }
      }
    },
    chartEventFilterValue() {
      let sw = ""
      const eventMap = window.chartEventBus.eventMap
      const idStr = `container_id_${this.myid.container_id}-rect_id_${this.myid.rect_id}`
      for (let i in eventMap) {
        if (eventMap[i].includes(idStr)) {
          const uid = getQueryParam("uid") || getDocumentCookie("UID") || ""
          sw = window.xinanhangkongPlugin
            ? `${window.chartEventBus.dataMap[i] || ""}`
            : `${uid}###${window.chartEventBus.dataMap[i] || ""}`
          break
        }
      }
      this.$changeOptionsEV(sw, "filterValue", false, null, this.myid, true)
      this.$changeOptionsEV(true, "hasSearch", false, null, this.myid, true)
      this.isSearch = true
      this.updateData(true)
    }
  }
}
